import BestValueCard from './BestValueCard';
import { BestValueCardProps, Perks } from './interfaces';

export type { BestValueCardProps, Perks };
export default BestValueCard;
